import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, ModuleFE_ActionProcessor, TS_AppTools, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ActionKey_ParseSnomedCSV } from '@app/hcs-shared';
import { ModuleFE_Reference } from '@app/hcs-frontend';
class DevPage_SnomedDictionaryActions_Renderer extends ComponentSync {
    render() {
        return _jsxs("div", { className: 'collection-upgrades-page', children: [TS_AppTools.renderPageHeader('Snomed Dictionary Actions'), _jsx(LL_H_C, { className: 'buttons-container', children: this.renderParseCSVButton() }), this.render_SnomedScraping()] });
    }
    renderParseCSVButton = () => {
        return _jsx(Button, { variant: 'primary', onClick: async () => {
                await ModuleFE_ActionProcessor.vv1.execute({ key: ActionKey_ParseSnomedCSV }).executeSync();
            }, children: "button" }, 'parse-csv-button');
    };
    render_SnomedScraping = () => {
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Scrape by search term', style: { padding: '20px' }, children: [_jsx(TS_Input, { type: 'text', value: this.state.searchTerm, onChange: v => this.setState({ searchTerm: v }) }), _jsx(Button, { onClick: async () => {
                        const term = this.state.searchTerm;
                        if (!term || term.length < 3)
                            return;
                        const response = await ModuleFE_Reference._snomed.scrapeBySearchTerm({ term }).executeSync();
                        console.table(response.results);
                    }, children: "Scrape" })] });
    };
}
export const ATS_SnomedDictionaryActions = {
    name: 'Snomed Dictionary Actions',
    key: 'snomed-dictionary-actions',
    renderer: DevPage_SnomedDictionaryActions_Renderer,
    group: 'Quai Dev Tools',
};
